import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { useSeo } from "@/lib/seo";

export default function NotServiceablePage() {
  useSeo({ title: "Coming Soon to Your Area | Soonyoung", noindex: true, path: "/pincode-not-serviceable" });
  const { pincodeInfo } = useStore();
  return (
    <section data-testid="not-serviceable-page" className="mx-auto flex min-h-[80vh] max-w-3xl flex-col items-center justify-center px-4 pt-28 text-center">
      <MapPin className="h-10 w-10 text-gold" />
      <h1 className="mt-4 font-display text-3xl tracking-tight text-cream sm:text-5xl">
        We're not in <span className="italic text-gold">{pincodeInfo?.state || "your area"}</span> yet
      </h1>
      <p className="mt-4 max-w-md text-sm leading-relaxed text-sage">
        {pincodeInfo?.message || "This pincode is outside our current delivery map."} The sanctuary is
        expanding state by state — leave your number at any store and we'll call when we arrive.
      </p>
      <Link to="/" data-testid="not-serviceable-home-btn" className="mt-8 rounded-full bg-gold px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] text-forest">
        Back to the Sanctuary
      </Link>
    </section>
  );
}
